<template>
 <div v-if="layout">
    <!-- Q1, Q3, Q5 LAYOUT -->
    <v-container v-if="displayLayout == layout.displayLayouts.K || displayLayout == layout.displayLayouts.J" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- Q2 (DOUBLE COMMENT BOX) LAYOUT -->
		<v-container v-else-if="displayLayout == layout.displayLayouts.E" grid-list-md>
			<!--<v-layout >
				<v-checkbox v-model="q2disable"></v-checkbox>&nbsp;
				<p style="margin-top:25px;">If your agency's report to OMB is not available to you, check this box to enter N/A in the data fields<span>&#x2e;</span></p>
			</v-layout>-->
			<div v-for="(row, index) in myRows" :key="index" >
				<v-layout >
					<v-flex xs12>
						<header-cell
							:isSub="false"
							:header="row.header"
							:label="row.label"
							:question="row.question"
							:question-id="row.questionId"
							:answer-id="row.answerId"
							:cell-id="row.cellId"
							:help="row.help"
							v-on:delete="deleteRow">
						</header-cell>
					</v-flex>
				</v-layout>

				<v-layout v-for="(sub, index2) in row.subs" :key="index2" >
					<v-flex :style="{'margin-top':'5px'}" xs5>
						<header-cell
							:isSub="true"
							:header="sub.header"
							:label="sub.label"
							:question="sub.question"
							:question-id="sub.questionId"
							:answer-id="sub.answerId"
							:cell-id="sub.cellId">
						</header-cell>
					</v-flex>
					<v-flex xs1>
						<value-cell
              class="tb-width"
							v-if="index2 == 1"
							:has-outline="hasOutline"
							:is-read-only="readOnly"
							:index="parseInt(index2)"
							:name="sub.answers[0].answerId"
							prefix="$"
							:value="myAnswer[0][sub.answers[0].answerId]"
							v-on:update="onUpdateAnswer"
							v-on:update:disable="q2disable = true"
							:disabled="q2disable"
              :id="qId"
						></value-cell>
						<computation-cell
              class="tb-width"
							v-if="index2 == 2"
							:id="qId"
							:name="sub.answers[0].answerId"
							:op="myProps[sub.answers[0].answerId + index2.toString()].op"
							:fields="myProps[sub.answers[0].answerId + index2.toString()].fields"
							:value="computeDifference(myProps[sub.answers[0].answerId + '0'].id, sub.answers[0].answerId, myAnswer[0][sub.answers[0].answerId])"
						></computation-cell>
						<ref-cell
            class="tb-width row-align"
							v-if="index2 == 0"
							:id="myProps[sub.answers[0].answerId + index2.toString()].id"
							:field="myProps[sub.answers[0].answerId + index2.toString()].field"
						></ref-cell>
					</v-flex>
				</v-layout>

				<v-flex v-if="index === 0" xs12>
					<p style="margin-left: 75px;">
						Use the space below to explain any differences between rows a.1 and a.2.
					</p>
					<textarea-autosize
						autosize
						class="comment-box"
						v-model="myAnswer[0].expBox1"
						:min-height="200"
						:max-height="400"
					/>
				</v-flex>
				<v-flex v-if="index === 1" xs12>
					<p style="margin-left: 75px;">
						Use the space below to explain any differences between rows b.1 and b.2.
					</p>
					<textarea-autosize
						autosize
						class="comment-box"
						v-model="myAnswer[0].expBox2"
						:min-height="200"
						:max-height="400"
					/>
				</v-flex>
			</div>
		</v-container>

    <!-- Q4 (RADIO BUTTON) LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.F" fluid grid-list-md>
      <v-layout>
        <v-flex class="left-label" xs3></v-flex>
        <v-flex v-for="(header, index) in likertScaleHeaders" :key="index" class="tb-width" xs1>
          <p class="radio-row-label">{{ header.label }}</p>
        </v-flex>
      </v-layout>

      <v-layout v-for="(row, index) in myRows" :key="index" >
        <v-flex class="left-label" xs3>
          <p class="row-label">{{ row.header }} {{ row.label }}</p>
        </v-flex>
        <v-radio-group v-model="myAnswer[0][row.answers[0].answerId]" row>
          <v-flex class="tb-width" v-for="(header, index) in likertScaleHeaders" :key="index" xs1>
            <v-radio class="radio-button" on-icon="radio_button_checked" off-icon="radio_button_unchecked" :value="header.value"></v-radio>
          </v-flex>
        </v-radio-group>
      </v-layout>
    </v-container>

    <!-- Q6, Q15 LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.D" grid-list-md>
     <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0][row.header]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="myAnswer[0]"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      >
		</answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1
          >
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- Q7, Q10 LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.B" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

     <!-- Q8, Q9, LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.B || displayLayout == layout.displayLayouts.G" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- A: {Q11}- NON-DOD and A:{Q12} -DOD -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.A" :v-on="getMyHeight()" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!--N: NON-DOD{Q12, Q13, DOD -13,14,15} LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.N" :v-on="getMyHeight()" grid-list-md>
			<answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <!--<answer-state
				:items="myRows"
				:qId="qId"
        ></answer-state>-->
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout>
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

		<!--C: NON-DOD{Q16, Q17, DOD -18,19} LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.C" :v-on="getMyHeight()" grid-list-md>
			<answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout>
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

		<!--Q20 NonDOD Layout-->
		<v-container v-else-if="displayLayout == layout.displayLayouts.M" grid-list-md>
			<answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[0]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
		</v-container>

		<!--J: {Q2} LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.L" grid-list-md>
      <answers-row
        v-for="(row, index) in myRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index]"
        :qColumns="qColumns"
        :key="index"
        :myRows="myRows"
        :fullAnswer="null"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
        v-on:update="onUpdateAnswer"
      ></answers-row>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex class="tb-width" v-for="(reference, index) in crossCheck.references" :key="index" xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

    <!-- Q14 LAYOUT -->
    <v-container v-else-if="displayLayout == layout.displayLayouts.H"  grid-list-md>
     <v-flex xs12>
      <header-cell
        :isSub="false"
        :header="myRows[0].header"
        :label="myRows[0].label"
        :question="myRows[0].question"
        :question-id="myRows[0].questionId"
        :answer-id="myRows[0].answerId"
        :cell-id="myRows[0].cellId"
        :help="myRows[0].help"
      ></header-cell>
      <table style="margin: 10px auto; border:0;">
      <tr>
      <td>
        <v-text-field width="20px" :has-outline="hasOutline" v-model="answers16or14.con0" :name="con" prefix="$" v-on:update="onUpdateAnswer" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></v-text-field>
      </td>
      <td>
        <v-text-field class="tb-width" :has-outline="hasOutline" v-model="answers16or14.pla0" :name="pla" prefix="$" v-on:update="onUpdateAnswer" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></v-text-field>
      </td>
      <td>
        <v-text-field readonly=true class="tb-width" :has-outline="hasOutline" v-model="answers16or14.tot0" :name="pla" prefix="$" v-on:update="onUpdateAnswer" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></v-text-field>
      </td>
      </tr>
      </table>
				<header-cell
					:isSub="false"
					:header="myRows[1].header"
					:label="myRows[1].label"
					:question="myRows[1].question"
					:question-id="myRows[1].questionId"
					:answer-id="myRows[1].answerId"
					:cell-id="myRows[1].cellId"
					:help="myRows[1].help"
				></header-cell>
					<div>
						<select id="CountriesControl" class="form-control" multiple="multiple" style="width:500px;margin-left:50px;height:300px">
							<option v-for="country in countriesList" :value="country.countryId" :key="country.countryId">{{ country.countryName }}</option>
						</select>
						<br/>
						&nbsp;&nbsp;&nbsp;&nbsp;<v-btn normal :class="isSurveyLocked" style="margin-left:10px;" color="primary" dark v-on:click="isSurveyLocked==null && onAddingCountries()">Add Countries</v-btn>
						&nbsp;<span style="color:blue;">{{countriesMessages}}</span>
						<br/> <br/>
						<p id="link">
							<div v-if="show">
								<b-container>
										<b-row class="mb-1">
											<b-col>
												<v-text-field v-model="countryName" label="Country" style="width:200px" readonly=true></v-text-field>
											</b-col>
											<b-col>
												<v-text-field v-model="con" label="Con" type="number" style="width:200px" prefix="$"></v-text-field>
											</b-col>
											<b-col>
												<v-text-field v-model="pla" label="Pla" type="number" style="width:200px" prefix="$"></v-text-field>
											</b-col>
											<b-col>
												<v-btn :class="isSurveyLocked" color="primary" dark v-on:click="isSurveyLocked==null && onSave()">Save Country</v-btn>
											</b-col>
										</b-row>
								</b-container>
							</div>
						</p>
						<v-flex xs12 class="horiz-margin-20">
							<v-data-table
								v-model="countriesSelection"
								:headers="countriesSelectionHeaders"
								:items="countries"
								class="elevation-1">
								<template #item.countryName = {value}>
									<a href="#link" v-on:click="isSurveyLocked==null && onEditCountries(value);">{{value}}</a>
								</template>
							</v-data-table>
						</v-flex>
					</div>
			<table>
      <tr>
				<td>
					<header-cell
						:isSub="false"
						:header="myRows[2].header"
						:label="myRows[2].label"
						:question="myRows[2].question"
						:question-id="myRows[2].questionId"
						:answer-id="myRows[2].answerId"
						:cell-id="myRows[2].cellId"
						:help="myRows[2].help"
					></header-cell>
			</td>
				<td style="padding-left:100px">
					<v-text-field readonly=true class="tb-width" :has-outline="hasOutline" v-model="answers16or14.con1" :name="pla" prefix="$" v-on:update="onUpdateAnswer" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></v-text-field>
				</td>
				<td style="padding:30px">
					<v-text-field readonly=true class="tb-width" :has-outline="hasOutline" v-model="answers16or14.pla1" :name="pla" prefix="$" v-on:update="onUpdateAnswer" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></v-text-field>
				</td>
				<td style="padding:30px">
					<v-text-field readonly=true class="tb-width" :has-outline="hasOutline" v-model="answers16or14.tot1" :name="pla" prefix="$" v-on:update="onUpdateAnswer" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"></v-text-field>
				</td>
      </tr>
		</table>
      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout>
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1>
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
      <br/>
			<div style="text-align:right;color:red;">
				<div id='errorLst'></div>
			</div>
			<br/>
      <div>If needed, use the space below to provide clarification for the data reported in this question.</div>
      <textarea-autosize autosize  class="comment-box" v-model="answers16or14.explanation"  :min-height="200" :max-height="400"/>
      <div style="text-align:left;position:absolute;bottom:0px;right:10px;">
          <p class="error" v-if="errors.column1">{{ errors.column2 }}</p>
          <p class="error" v-if="errors.column1">{{ errors.column3 }}</p>
			</div>
			<div>
				<v-btn normal :class="isSurveyLocked" style="margin-left:10px;" color="primary" dark v-on:click="isSurveyLocked==null && onSaveClick()">Save</v-btn>
				&nbsp;<span style="text-align:left;color:blue;" id="surveyLockedDisplayText" v-if="isSurveyLocked!=null">Survey has been submitted and locked.</span>
				&nbsp;<b style="text-align:left;" v-if="errors.column1">{{ errors.column1 }}</b>
			</div>
     </v-flex>
    </v-container>

    <!-- Q18 LAYOUT -->
	  <v-container v-else-if="displayLayout == layout.displayLayouts.I"  grid-list-md>
			<div v-if="loading">
				<br>
				<v-progress-linear
					indeterminate
					color="blue"
				></v-progress-linear>
			</div>

			<v-layout v-if="!loading">
				<v-dialog v-model="dialog" persistent max-width="500">
					<!--<template v-slot:activator="{ on }">
						<v-checkbox v-model="checkboxState"></v-checkbox>&nbsp;
					</template>-->
					<v-card>
						<v-card-title class="headline red--text text--darken-2">Are you sure you want to continue?</v-card-title>
						<v-card-text class="black--text text-left">
							<p><b>All data</b> entered for this question will be <b>permanently deleted.</b></p>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="red darken-2" text @click="dialog = false; checkboxState = false">Cancel</v-btn>
							<v-btn color="green darken-2" text @click="setOrganizationQuestionNA($event)">Continue</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			<!--<p style="margin-top:25px;" v-if="(qId == 18) || (qId == 20)">Check this box if your office does not provide support to any individual U.S. higher education institutions.</p>
			<p style="margin-top:25px;" v-if="(qId == 19) || (qId == 21)">Check this box if your office does not provide support to any individual U.S. nonprofit organizations other than higher education institutions.</p>-->
			</v-layout>
			<answers-row
				v-if = "!loading"
        v-for="(row, index) in myDynamicRows"
        :row="row"
        :qId="qId"
        :answers="myAnswer[index + 1]"
				:qColumns="qColumns"
        :key="index + 1"
        :myRows="myDynamicRows"
        :fullAnswer="null"
        :isDynamic="true"
        v-on:update="onUpdateAnswer"
        v-on:delete="deleteRow"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
      ></answers-row>

			<answers-row
        :row="myRows[0]"
        :qId="qId"
        :answers="myAnswer[0]"
				:qColumns="qColumns"
        :key="0"
        :myRows="myRows"
        :fullAnswerArray="myAnswer"
        v-on:update="onUpdateAnswer"
        :displayLayout="displayLayout"
        :displayLayouts="layout.displayLayouts"
				:hasExp="hasExp"
				v-on:update:disable="iLayoutDisable = true; checkboxState = true"
				:isNA="iLayoutDisable"
      ></answers-row>

      <div v-if="Boolean(crossCheck)" class="cCheck">
        <v-layout >
          <v-flex class="left-label" xs3><i>{{crossCheck.label}}</i></v-flex>
          <v-flex
            class="tb-width"
            v-for="(reference, index) in crossCheck.references"
            :key="index"
            xs1
          >
            <ref-cell :reference="reference"></ref-cell>
          </v-flex>
        </v-layout>
      </div>
    </v-container>

  </div>
</template>

<script>
import { answerService } from '../../services/answerService';
import { authTokenService } from '@/services/authTokenService.js';
import { surveyService } from "@/services/surveyService.js";
import { CONSTANTS } from '@/common/constants';
import { lookUpService } from "../../services/lookUpService";
import { errorService } from '../../services/errorService';

export default {
  name: 'AnswerMatrix',
  props: {
    layout: Object,
    qId: String,
    displayErrors: Boolean,
    columns: Array,
    displayLayout: Number,
		crossCheck: Object,
		hasExp: Boolean,
    isStandardSurvey: Boolean
  },
  data: () => ({
    myMatrix: null,
    myAnswer: null,
    myProps: null,
    myColumns: null,
    qColumns: [],
    myRows: null,
    myDynamicRows: [],
    hasOutline: false,
    readOnly: false,
		q2disable: false,
		iLayoutDisable: false,
		checkboxState: false,
		dialog: false,
    likertScaleHeaders: [
      { value: '0', label: 'None or not applicable' },
      { value: '1', label: 'Less than $1 million' },
      { value: '2', label: '$1,000,000 to $9,999,999' },
      { value: '3', label: '$10,000,000 to $49,999,999' },
      { value: '4', label: '$50,000,000 or more' },
      { value: '5', label: 'Not available' }
    ],
		myHeight: Number,
    countriesSelection: [],
    countriesSelectionHeaders: [
      { text: 'Countries', value: 'countryName', class: 'cellclname' },
      { text: 'R&D conduct', value: 'con' },
      { text: 'R&D plant', value: 'pla' },
      { text: 'Total R&D conduct and plant', value: 'tot' }
    ],
    countries: [],
    Message: null,
    headingtitle: null,
    countryName: null,
    con: null,
    pla: null,
    tot: null,
    countryId: null,
    answers16or14: {
      con0: null,
      pla0: null,
      tot0: null,
      con1: null,
      pla1: null,
      tot1: null,
      explanation: null
    },
    errors: {
      column1: null,
      column2: null,
      column3: null,
			validationMessages: null
    },
    addCountries: {
      selectCountry: null
    },
    countryList: [],
    countriesList: [],
    countriesMessages: null,
    selectedCountriesList: [],
    isSurveyLocked: null,
    cvolume: null,
    show: false
  }),
  computed: {
    answer: function () {
      return this.$store.getters['answersArray'];
		},
		loading: function () {
      return this.$store.getters['isLoading'];
		}
  },
  watch: {
		layout: function (newVal, oldVal) {
      if (newVal) {
        this.myMatrix = this.layout.matrix;
        this.myRows = !this.myMatrix.rows || this.myMatrix.rows.length == 0 ? this.myMatrix : this.myMatrix.rows;
        this.myAnswer = this.layout.answer;
        this.myProps = this.layout.props;
        this.myColumns = this.layout.columns;
        if (this.displayLayout == this.layout.displayLayouts.I) {
					var tempCol = [];
					for (var i = 1; i < this.myColumns.length; i++) {
						for (var j = 0; j < this.myColumns[i].labels.length; j++) {
							tempCol.push(this.myColumns[i].labels[j]);
						}
					}
					this.myColumns = tempCol;
					this.qColumns = tempCol;
					for (var i = 1; i < this.layout.answer.length; i++) {
						if (this.qId == "18") {
							this.createNewDynamicRow(this.layout.answer[i].insCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						} else if (this.qId == "19") {
							this.createNewDynamicRow(this.layout.answer[i].orgCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						} else if (this.qId == "20") {
							 this.createNewDynamicRow(this.layout.answer[i].insCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						} else if (this.qId == "21") {
							 this.createNewDynamicRow(this.layout.answer[i].orgCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						}
					}
				}
				this.countriesError(this.qId);
			}
    },
		columns: function (newVal, oldVal) {
      this.qColumns = newVal;
		},
		myAnswer: function (newVal, oldVal) {
        if (this.displayLayout == this.layout.displayLayouts.I) {
          // This should only run when the Question component changes the answer object
          if (newVal.length - 2 == this.myDynamicRows.length && newVal.length > 1) {
            if (this.qId == "18") {
							this.createNewDynamicRow(this.layout.answer[i].insCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						} else if (this.qId == "19") {
							this.createNewDynamicRow(this.layout.answer[i].orgCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						} else if (this.qId == "20") {
							 this.createNewDynamicRow(this.layout.answer[i].insCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						} else if (this.qId == "21") {
							 this.createNewDynamicRow(this.layout.answer[i].orgCon, this.layout.answer[i].orgCod, this.layout.answer[i].stateCode);
						}
          }
        }
		},
		checkboxState: function (newVal, oldVal) {
			if (newVal === true && this.iLayoutDisable === false) {
				this.dialog = true;
			} else if (newVal === false) {
				this.iLayoutDisable = false;
				this.$store.commit('setIsLoading', { isLoading: true });
				this.$emit('update:disable:search', false)
				this.$emit('save');
			} else if (newVal === true && this.iLayoutDisable === true) {
				this.$emit('update:disable:search', true);
			}
		},
    selectedCountries: function (newVal, oldVal) {
			this.values = [];

			this.selectedCountries.forEach(entry => {
				if (entry.countryId !== CONSTANTS.COUNTRY_STATIC_ROW_NAMES.A_ROW && entry.countryId !== CONSTANTS.COUNTRY_STATIC_ROW_NAMES.C_ROW) {
					this.values.push(entry.countryId);
				}
			});
			this.values.sort();
		}
  },
  mounted () {
    debugger;
    this.cvolume = authTokenService.getCurrentVolume();
    this.$store.commit('setIsLoading', { isLoading: false });
    const claims = authTokenService.getClaims();
    const activeId = authTokenService.getActiveSurveyId();
    if (claims.surveyId !== undefined && typeof claims.surveyId === 'string') {
      claims.surveyId = activeId;
    }
    if (this.qId === "16" || this.qId === "14") {
			this.onLoad();
			const me = this;
      me.countriesList = [];
      me.countryList = [];
      lookUpService.loadLookUpCountries('country').then(function (response) {
          if (response && response.data) {
            me.countryList.push(response.data);
            for (var i = 0; i < me.countryList[0].length; i++) {
              me.countriesList.push(me.countryList[0][i]);
            }
          }
        });
			me.countriesError(me.qId);
		}
    this.setIsLocked();
  },
  methods: {
    onAddingCountries () {
      var vqId = this.qId;
      const me = this;
      me.countriesMessages = "Processing please wait..";
      me.selectedCountriesList = [];
      for (var option of document.getElementById('CountriesControl').options) {
          if (option.selected) {
              me.selectedCountriesList.push(option.value);
          }
      }
      const claims = authTokenService.getClaims();
      const activeId = authTokenService.getActiveSurveyId();
      if (claims.surveyId !== undefined && typeof claims.surveyId == 'string') {
        claims.surveyId = activeId;
      }
      surveyService.saveCountries(claims.surveyId, me.selectedCountriesList, claims.userName, vqId)
        .then(function (response) {
            me.message = response.data;
            me.countries = [];
            setTimeout(() => {
						me.onLoad();
            me.selectedCountriesList = [];
            me.countriesMessages = "";
					}, 2000);
        });
    },
    onSave () {
      debugger;
      console.log("save calling..");
      var vqId = this.qId;
      const me = this;
      const activeSurveyId = authTokenService.getActiveSurveyId();
      surveyService.saveAnswerCountries(activeSurveyId, me.countryId, me.con, me.pla, me.tot, vqId)
      .then(function (response) {
          me.message = response.data;
          me.show = false;
          me.countriesMessages = "Successfully updated the list, please click below Save button for further validation.";
          me.countries = [];
      });
			me.countriesError(vqId);
			setTimeout(() => { me.onLoad(); }, 2000);
    },
    onSaveClick () {
      debugger;
      var answers = this.myAnswer;
      var vqId = this.qId;
      const me = this;
      me.errors.column1 = "Processing please wait..";
      if (me.isSurveyLocked != null) {
        me.errors.column1 = "Survey has been submitted and locked.";
        return;
      }
      me.$data.isLoading = true;
      const claims = authTokenService.getClaims();
      const activeId = authTokenService.getActiveSurveyId();
      if (claims.surveyId != undefined && typeof claims.surveyId == 'string')
      {
        claims.surveyId = activeId;
      }
      var con = 0;
      var pla = 0;
      answerService.getAvaiableCountries(claims.surveyId, vqId).then(function (response) {
        if (response && response.data) {
          answers = response.data;
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].countryId != "91000" && response.data[i].countryId != "90009") {
                answers[i].con = (response.data[i].con == null || response.data[i].con == '') ? 0 : parseInt(response.data[i].con);
                answers[i].pla = (response.data[i].pla == null || response.data[i].pla == '') ? 0 : parseInt(response.data[i].pla);
                answers[i].tot = parseInt(answers[i].con) + parseInt(answers[i].pla);
                con += parseInt(answers[i].con);
                pla += parseInt(answers[i].pla);
                answers[i].countryId = response.data[i].countryName;
            } else if (response.data[i].countryId == "90009") {
                answers[i].con = (me.answers16or14.con0 == null || me.answers16or14.con0 == '') ? 0 : parseInt(me.answers16or14.con0);
                answers[i].pla = (me.answers16or14.pla0 == null || me.answers16or14.pla0 == '') ? 0 : parseInt(me.answers16or14.pla0);
                answers[i].tot = parseInt(answers[i].con) + parseInt(answers[i].pla);
                con += parseInt(answers[i].con);
                pla += parseInt(answers[i].pla);
                answers[i].countryId = response.data[i].countryName;
                answers[i].expBox = me.answers16or14.explanation;
            }
          }
          //For Total:
          for(var i=0; i<response.data.length; i++)
          {
            if(response.data[i].countryId == "91000")
            {
                answers[i].con = parseInt(con);
                answers[i].pla = parseInt(pla);
                answers[i].tot = parseInt(answers[i].con) + parseInt(answers[i].pla);
                answers[i].countryId = response.data[i].countryName;
                break;
            }
          }
          //Calling save..
          answerService.saveAnswer(vqId, answers, true).then(function (response)
          {
              if (response && CONSTANTS.HTTP.NO_CONTENT === response.status)
              {
								 me.countriesError(vqId);
                 me.errors.column1 = "Saved Successfully";
                 me.$data.isLoading = false;
                 me.countries = [];
                 setTimeout(() => {  me.onLoad(); }, 2000);
              }
          });
        }
      });
    },
		countriesError (vqId) {
				const me = this;
				me.$store.dispatch('validation/loadQuestionStatuses');
				me.$store.dispatch('validation/loadSurveyValidationMessages');
				errorService.getValidationMessagesForQuestion(vqId).then(function (response) {
					var library = response.data.validationItems;
					var output = '';
					var count = 1;
					for (var lib of library) {
						for (var key in lib) {
							if (key == 'title')
								output += `<ul><li>` + count + " " + lib[key] + " ";
							if (key == 'message')
								output += " " + lib[key] + `</li></ul>`;
						}
						count++;
					}
					if (vqId == 14 || vqId == 16) {
						document.getElementById('errorLst').innerHTML = output
					}
					else if (vqId == 20) {
						document.getElementById('errorList').innerHTML = output
					}
				});
		},
    onEditCountries (countryname) {
      var vqId = this.qId;
      const me = this;
      me.headingtitle = "Update Country info";
      const claims = authTokenService.getClaims();
      const activeId = authTokenService.getActiveSurveyId();
      claims.surveyId = activeId;
      surveyService.getCountryInfo(countryname, claims.surveyId, vqId).then(function (response) {
        if (response && response.data) {
            me.countryName = response.data.countryName;
            me.con = response.data.con;
            me.pla = response.data.pla;
            me.tot = response.data.tot;
            me.countryId = response.data.countryId;
        }
      });
      me.countriesMessages = "";
      me.show = true;
    },
    onLoad () {
        var answers = this.myAnswer;
        var val = this.qId;
        const me = this;
        const activeSurveyId = authTokenService.getActiveSurveyId();
        me.countries = [];
        answerService.getAvaiableCountries(activeSurveyId, val).then(function (response) {
          if (response && response.data) {
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].countryId != "90009" && response.data[i].countryId != "91000") {
                me.countries.push(response.data[i]);
              } else if (response.data[i].countryId == "90009") {
                  me.answers16or14.con0 = response.data[i].con;
                  me.answers16or14.pla0 = response.data[i].pla;
                  me.answers16or14.tot0 = response.data[i].tot;
                  me.answers16or14.explanation = response.data[i].expBox;
              } else if (response.data[i].countryId == "91000") {
                  me.answers16or14.con1 = response.data[i].con;
                  me.answers16or14.pla1 = response.data[i].pla;
                  me.answers16or14.tot1 = response.data[i].tot;
              }
            }
          }
        });
    },
    getMyHeight () {
      var height = this.myAnswer.length;
    },
    onUpdateAnswer: function (val) {
      this.$emit('update', val);
    },
		onUpdateRows: async function (val) {
      debugger;
			this.$store.commit('setIsLoading', { isLoading: true });
			var currentEntries = [];
			for (let i = 1; i < this.layout.answer.length; i++) {
				currentEntries.push(this.layout.answer[i].countryId);
			}

			for (let i = 0; i < currentEntries.length; i++) {
				if (val.searchValues.findIndex(element => element == currentEntries[i]) == -1) {
					// entriesToDelete.push(currentEntries[i]);
					await this.removeDynamicRow(currentEntries[i], true);
				}
			}

			for (let i = 0; i < val.searchValues.length; i++) {
				if (currentEntries.findIndex(element => element == val.searchValues[i]) == -1) {
					// entriesToInsert.push(val.searchValues[i]);
					this.createNewAnswerEntry(val.searchValues[i]);
					this.createNewDynamicRow(val.searchValues[i]);
				}
			}
      console.log("calling Save method");
  		this.$emit('save');
    },
    createNewAnswerEntry: function (idName) {
      debugger;
      var temp = Object.assign({}, this.layout.answer[0]);
      for (var key in temp) {
        if (temp.hasOwnProperty(key)) {
          if (typeof temp[key] === 'number' || typeof temp[key] === 'object') {
            temp[key] = 0;
          } else {
            temp[key] = null;
          }
        }
      }

      temp.status = 'InProgress';
      temp.countryId = idName;
      temp.createDate = '0001-01-01T00:00:00';
      temp.updateDate = '0001-01-01T00:00:00';
      this.myAnswer.push(temp);
    },
    getTotalNumCols () {
      console.log('this.qColumns: ' + JSON.stringify(this.qColumns));
      var numCols = 0;
      var i;
      for (i = 0; i < this.qColumns.length; i++) {
        numCols++;
      }
      console.log('numCols: ' + numCols);
      return numCols;
    },
    createNewDynamicRow: function (rowName, rowCode = "", stateCode = "") {
      debugger;
			var cellNames = Object.keys(this.layout.answer[0]);
			var cellNameIndx;
			// Organization Dynamic rows cell values start at pos 4
			if (this.displayLayout == this.layout.displayLayouts.I) {
				cellNameIndx = 4;
			}
      let cellId = '';
      let qaRow = {
        header: rowCode.toString(),
        label: rowName,
        help: '',
				state: stateCode.toString()
      };
      qaRow.answers = [];
			this.myColumns.forEach(id => {
        cellId = cellNames[cellNameIndx] + ' ' + this.qId;
        qaRow.answers.push({
          cellId: cellId,
          answerId: cellNames[cellNameIndx],
          questionId: '',
          question: null
        });
				console.log("qaRow" + this.qaRow);
        cellNameIndx++;
      });
      this.myDynamicRows.push(qaRow);
    },
    removeDynamicRow: async function (rowName, callDelete) {
      var answerFound = false;
			var rowFound = false;
			var answerPos = -1;
			var rowPos = -1;
			for (var i = 0; i < this.myDynamicRows.length && !(answerFound && rowFound); i++) {
				if ((this.myDynamicRows[i].header === rowName && this.displayLayout == this.layout.displayLayouts.I) ||
					  (this.myDynamicRows[i].label == rowName)) {
					rowPos = i;
          rowFound = true;
        }

        if (this.displayLayout === this.layout.displayLayouts.I) {
					if (this.myAnswer[i + 1].orgCod === rowName) {
						// this.myAnswer.splice(i + 1, 1);
						answerPos = i + 1;
						answerFound = true;
					}
				}
      }

			var me = this;
			if (callDelete) {
				if (answerFound) {
					const activeId = authTokenService.getActiveSurveyId();
          console.log('rowName', rowName);
					await answerService
						.deleteAnswerDynamicRow(activeId, this.qId, rowName)
						.then(async function (response) {
							if (response && response.data) {
								if (answerPos !== -1) {
									me.myAnswer.splice(answerPos, 1);
								}

								if (rowPos !== -1) {
									me.myDynamicRows.splice(rowPos, 1);
								}
								return await Promise.resolve(1);
							}
						})
						.catch(async function (e) {
							console.log('Could not delete row');
							console.log(e);
							return await Promise.resolve(1);
						});
				}
			} else {
				if (answerPos !== -1) {
					me.myAnswer.splice(answerPos, 1);
				}

				if (rowPos !== -1) {
					me.myDynamicRows.splice(rowPos, 1);
				}
				return await Promise.resolve(1);
			}
    },
    getTotalRows: function (numRows, answer, index2) {
      debugger;
      var i;
      var sum = 0;
      for (i = 0; i < numRows; i++) {
        sum += answer[this.myRows[i][index2].id];
      }
      return sum;
    },
    computeDifference: function (id, name, value) {
      if (value == Number.MIN_SAFE_INTEGER) {
        return Number.MIN_SAFE_INTEGER;
      }
      const ans = this.answer;
      var v;
      if (ans && id) {
        const val = ans[id];
        const value1 = val[0] ? val[0][name] : 0;
        v = value1;
      } else {
        v = answerService.getAnswerValue(0);
      }
      return v - value;
    },
    deleteRow: function (val) {
      this.removeDynamicRow(val.rowName, true);
		},
		setOrganizationQuestionNA: function () {
      debugger;
			this.dialog = false;
      this.iLayoutDisable = true;
			this.myAnswer.splice(1, this.myDynamicRows.length);
			this.myDynamicRows = [];
      const activeId = authTokenService.getActiveSurveyId();
      answerService.deleteOrganization(activeId, this.qId).then(function (response) {
          if (response && response.data) {
            this.iLayoutDisable = false;
            this.$store.commit('setIsLoading', { isLoading: false });
            return response.data;
          }
        })
        .catch(function (e) {
          console.log('Could not delete row');
          this.iLayoutDisable = false;
					this.$store.commit('setIsLoading', { isLoading: false });
			});
		},
    setIsLocked: function () {
			const me = this;
      me.activeId = authTokenService.getActiveSurveyId();
			surveyService.getLockStatus(me.activeId).then(function (response) {
				if (response && response.data != null) {
					if (response.data.isLocked == true) {
							me.isLocked = true;
              me.isSurveyLocked = "isDisabled";
							me.lockMessage = "This survey has been submitted and locked."
					}	else if (response.data.currentUser != null) {
						me.isLocked = true;
						me.lockMessage = `The survey is in use by user: ${response.data.currentUser}`;
					}	else {
            me.isSurveyLocked = null;
						me.lockMessage = null;
					}
				}
			})
			.catch(function (e) {
				console.log(e);
				console.log('Error loading survey lock status')
				throw e;
			});
     return me.isLocked;
		}
  }
};
</script>

<style scoped>
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}
h2 {
  font-size: 12pt;
  margin-left: 25px;
}
.right_button {
  text-align: right;
}
.row-label-head {
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
  margin-left: 0px;
}
.row-label {
  font-weight: bold;
  text-align: left;
  margin-top: 10px;
  margin-left: 0;
}
.row-label-sub {
  font-weight: normal;
  text-align: left;
  margin-top: 10px;
  /*margin-left: 75px;*/
}
.row-label-help {
  font-weight: normal;
  text-align: left;
  /*margin-left: 5%;*/
}
.radio-row-label {
  font-weight: bold;
  text-align: center;
}
.radio-button {
  margin-left: 60px;
  text-align: center;
  /* border-style: solid; */
}
.question-content .v-text-field {
  width: 70%;
  margin: 0 auto;
}
.comment-box {
  min-width: 80%;
  background: white;
  /*margin-left: 75px;*/
  margin-bottom: 40px;
}
.left {
  justify-content: left;
}
.tb-width {
  min-width: 150px;
}
.row-align {
  margin-top: 17px;
}
.left-label {
   margin-top: 17px;
   min-width: 450px;
}
.error {
    color: red;
}
select.mySelect{
    background: #20d492;
    color: #fff;
    padding: 0 10px;
    font-size: 12pt;
}
select.mySelect option{
	color: #000;
    padding: 0 10px;
}

</style>
